export const GenderOptions = [
  {
    value: "1",
    label: "Male",
  },
  {
    value: "2",
    label: "Female",
  },
  {
    value: "3",
    label: "Others",
  },
];

export const visaTypeOptions = [
  {
    value: "citizen",
    label: "Citizen",
  },
  {
    value: "greenCard",
    label: "Green Card",
  },
  {
    value: "H1B",
    label: "H1B",
  },
  {
    value: "H4",
    label: "H4",
  },
  {
    value: "H4EAD",
    label: "H4 EAD",
  },
  {
    value: "L1",
    label: "L1",
  },
  {
    value: "L2",
    label: "L2",
  },
  {
    value: "J1",
    label: "J1",
  },
  {
    value: "J2",
    label: "J2",
  },
  {
    value: "B1",
    label: "B1",
  },
  {
    value: "B2",
    label: "B2",
  },
  {
    value: "F1",
    label: "F1",
  },
  {
    value: "F1OPT",
    label: "F1 OPT",
  },
  {
    value: "F1CPT",
    label: "F1 CPT",
  },
  {
    value: "F1STEMCPT",
    label: "F1 STEM CPT",
  },
  {
    value: "STEMCPT",
    label: "STEM CPT",
  },
  {
    value: "F2",
    label: "F2",
  },
  {
    value: "M",
    label: "M",
  },
  {
    value: "Q",
    label: "Q",
  },
  {
    value: "EAD",
    label: "EAD",
  },
  {
    value: "TN",
    label: "TN",
  },
  {
    value: "TD",
    label: "TD",
  },
  {
    value: "O",
    label: "O",
  },
  {
    value: "O3",
    label: "O3",
  },
  {
    value: "GC",
    label: "GC",
  },
  {
    value: "GCEAD",
    label: "GC EAD",
  },
  {
    value: "CZ",
    label: "CZ",
  },
  {
    value: "NotAvailble",
    label: "Not Availble",
  },
  {
    value: "OtherVisa",
    label: "Other Visa",
  },
];

export const totalMonthsInUs = [
  {
    value: "1",
    label: "1",
  },
  {
    value: "2",
    label: "2",
  },
  {
    value: "3",
    label: "3",
  },
  {
    value: "4",
    label: "4",
  },
  {
    value: "5",
    label: "5",
  },
  {
    value: "6",
    label: "6",
  },
  {
    value: "7",
    label: "7",
  },
  {
    value: "8",
    label: "8",
  },
  {
    value: "9",
    label: "9",
  },
  {
    value: "10",
    label: "10",
  },
  {
    value: "11",
    label: "11",
  },
  {
    value: "12",
    label: "12",
  },
];

export const yesNoOptions = [
  {
    value: "1",
    label: "Yes",
  },
  {
    value: "0",
    label: "No",
  },
];

export const marriageStatus = [
  {
    value: "1",
    label: "Single",
  },
  {
    value: "2",
    label: "Married",
  },
  {
    value: "3",
    label: "Other",
  },
];

export const relationShipOptions = [
  {
    value: "2",
    label: "Son",
  },
  {
    value: "3",
    label: "Daughter",
  },
  {
    value: "4",
    label: "Mother",
  },
  {
    value: "5",
    label: "Father",
  },
  {
    value: "6",
    label: "Brother",
  },
  {
    value: "7",
    label: "Sister",
  },
  {
    value: "8",
    label: "Others",
  },
  {
    value: "9",
    label: "In-laws",
  },
];

export const identificationOptions = [
  {
    value: "1",
    label: "SSN / ITIN",
  },
  {
    value: "2",
    label: "To Apply ITIN",
  },
];

export const dependentEmptyContext = {
  firstName: "",
  middleName: "",
  lastName: "",
  dob: "",
  gender: "",
  relation: "",
  visaType: "",
  changeInVisa2022: "",
  countryOfCitizenship: "",
  dateOfEntryInUs: "",
  identificationNumber: "",
  ssnItinNumber: "",
  itinnVisaNumber: "",
  passportNumber: "",
  passportExpiryDate: "",
  foreignHomeAddress: "",
  dateOfChange: "",
  fromVisa: "",
  toVisa: "",
};

export const spouseEmptyContext = {
  changeInVisa2022: "",
  dateOfEntryInUs: "",
  dob: "",
  firstName: "",
  foreignHomeAddress: "",
  identificationNumber: "",
  itinnVisaNumber: "",
  lastName: "",
  middleName: "",
  passportExpiryDate: "",
  passportNumber: "",
  ssnItinNumber: "",
  visaType: "",
  dateOfChange: "",
  fromVisa: "",
  toVisa: "",
  dom: "",
  occupation: "",
};
